import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AdminMenu {
  id: number;
  label: string;
  route: string;
  icon: string;
  group: string | null;
  permission: string;
  sortOrder: number;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AdminMenuService {
  private apiUrl = environment.apiBaseUrl + '/api/admin-menus';

  constructor(private http: HttpClient) { }

  getByRole(roleId: number): Observable<AdminMenu[]> {
    return this.http.get<any>(`${this.apiUrl}/by-role/${roleId}`).pipe(
      map((res) => {
        const menus: AdminMenu[] = res?.data || [];

        return menus
          .filter((menu) => menu.isActive)
          .sort((a, b) => a.sortOrder - b.sortOrder);
      })
    );
  }
}
